import { getBranchCode } from "~/helpers/branch";
import { getDomainByBranch } from "~/helpers/domain";

export default defineNuxtPlugin({
  name: 'domain',
  dependsOn: ['branch'],
  setup() {
    const code = getBranchCode();
    return {
      provide: {
        domain: getDomainByBranch(code)
      }
    };
  }
});